// extracted by mini-css-extract-plugin
export default {"main":"CatAndLoc_main__TiTpA","categories":"CatAndLoc_categories__6bZMN","option":"CatAndLoc_option__Hb7ZI"};